import React, { Component, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Utility,{ deepClone } from "../../../../utility/Utility"
import { showLoader,showAlert,showToast,removeLoader,TOAST_TYPE } from "deskera-ui-library";
import DataGridHolderPayroll from "../../../common/DataGridHolderPayroll";
import { parseColumnConfig, EmployeeTaxColumnConfig, changeColumnName } from "../../../configs/config";
import EmployeeTaxService from "../../../../services/EmployeeTaxService";
import { TableManger, TABLES } from "../../../../managers/TableManger";
import { fetchEmployeeTAX, selectEmployeeTAX, selectEmployeeTAXColumnConfig } from "../../../../Redux/Slices/EmployeeTaxSlice";
import { EMPLOYEE_STAGE, INVESTMENT_STAGE, RESET_STAGE } from "./InvestmentConstants";
import RouteManager from "../../../../managers/RouteManager";
import { getQueryParam } from "../../../../managers/common/CommonUtil";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import moment from "moment";
import { DATE_FORMAT } from "../../../../constants/Constant";
import PermissionUtils, { ACTION, MODULE } from "../../../user-permissions/PermissionUtils";

const Employees = (props) => {
    const history = useHistory();

    const STAGE = props.stage || getQueryParam(props.location, "stage");

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    //State hooks
    const [refresh, setRefresh] = useState(false);
    const [employee, setEmployee] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [userData, setUserData] = useState(null);
    
    let userId = null;
    let employeeName = null;

    //Store data selectors
    const dispatch = useDispatch();
    const EmployeeData = useSelector(selectEmployeeTAX);
    const columnConfig = useSelector(selectEmployeeTAXColumnConfig);
    
    const isActionEnabled = true;

    useEffect(() => {
        RouteManager.setPresenter({props: {...props, history: history}});

        showLoader();
        /* API Calls Start */
        const config = {
            Limit: 20,
            currentPage: 1,
            order: 'desc',
            field: '_id',
            stage: STAGE
        };
        
        loadEmployee(config);
        /* API Calls End */
        return () => setEmployee(initialState);
    }, [])

    useEffect(() => {
        const config = {
            ...EmployeeTaxService.apiConfig,
            Page: 0,
            stage: STAGE
        };
        loadEmployee(config);
    }, [STAGE])

    useEffect(() => {
        if (!Utility.isEmpty(EmployeeData)) {
            RouteManager.setPresenter({ props: props });
            const { taxDeclarationInfo, filterConfig } = EmployeeData;
            const functionConfig = getFunctionConfig()
            const rowData = EmployeeTaxColumnConfig(taxDeclarationInfo,STAGE,functionConfig);
            let columns = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_EMPLOYEE_TAX_DECLARATION))
            columns = changeColumnName(columns,STAGE)
            const passingData = {
                columnData: deepClone(columns),
                rowData,
                filter: [],
                originalData: rowData
            };
            setEmployee(passingData);
            setTotalPageCount(parseInt(filterConfig.totalPage));
            setCurrentPage(parseInt(filterConfig.page));
            setTotalCount(parseInt(filterConfig.numberOfRecords))

        }
    }, [EmployeeData, STAGE]);

    const getHasResetPermission = (stage) => {
        let module;
        if (stage === INVESTMENT_STAGE.ACTUAL) {
            module = MODULE.EMPLOYEE_POI;
        } else if (stage === INVESTMENT_STAGE.APPROVED) {
            module = MODULE.EMPLOYEE_APPROVAL;
        } else {
            module = MODULE.EMPLOYEE_DECLARATION;
        }

        return PermissionUtils.hasAccess(module, ACTION.RESET);
    }

    const getFunctionConfig = () => {
        let config = {
            "deleteIT": deleteIT,
            "isResetAllowed": getHasResetPermission
        };
        return config;
    }
    const getFinancialYears = () => {
        const years = [];

        const todayYear = moment().year();
        const todayMonth = moment().month();

        let startYear = todayMonth > moment().month("March").month() ? todayYear : todayYear - 1;
        const endYear = todayMonth > moment().month("March").month() ? todayYear + 1 : todayYear;

        const dateOfCreation = TenantService.get(TENANT.DATE_OF_CREATION);
        if (dateOfCreation) {
            const dateOfCreationYear = moment(dateOfCreation, DATE_FORMAT.YYYYMMDD).year();
            if (dateOfCreationYear < startYear) {
                startYear = dateOfCreationYear;
            }
        }

        while(startYear !== endYear) {
            years.push(String().concat(startYear, " - ", startYear + 1));
            startYear++;
        }

        return years;
    }
    const getFinancialYearStartDate = () => {
        const financialYears = getFinancialYears();
        const defaultFinancialYear = financialYears[financialYears.length - 1];
        let startDate = null;
        const selectedFinancialYear = defaultFinancialYear;
        if (selectedFinancialYear) {
            startDate = moment([selectedFinancialYear.split(" - ")[0], 3, 1]);
        }
        return startDate;
    }
    
    const deleteIT = (data) => {
        
        let payload = {
            stage: INVESTMENT_STAGE[STAGE],
            employees: [data.rowData.employee.userId],
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD)
        }
        showLoader();
        EmployeeTaxService.deleteTaxDeclaration(payload).then(res=>{
            removeLoader();
            const config = {
                ...EmployeeTaxService.apiConfig
            };
            showToast(`${RESET_STAGE[STAGE] || "IT Declaration"} is reset successfully.`,TOAST_TYPE.SUCCESS);
            loadEmployee(config);
        },error=>{
            removeLoader()
            if(error && (error.errorMessage || error.message)) {
                showAlert('Alert',error.errorMessage || error.message);
            } else {
                showToast("Something went wrong.",TOAST_TYPE.FAILURE);
            }
        })
        
    }
    const loadEmployee = async (config) => {
        try {
            showLoader()
            EmployeeTaxService.apiConfig = config;
            await dispatch(fetchEmployeeTAX());
        } catch (err) {
            console.error('Error loading employees: ', err);
        }
    };

    const onRowEdit = (data) => {
        const {rowIndex, rowData} = {...data};
        onRowClick(rowIndex, rowData);
    };

    const onSearch = (searchTerm) => {
        const config = {
            ...EmployeeTaxService.apiConfig,
            Page: 0,
            SearchTerm: searchTerm,
            stage:STAGE
        };
        loadEmployee(config);
    };
    const newColumnAdded = (data) => {
        
    };

    const onFilter = (updatedList, queries) => {

    };

    const onRowAdd = (newRow) => {

    };
    
    const onDeleteEmployee = (ele) => { 
        
    }

    const onRowClick = (index, data) => {
        switch (STAGE) {
            case INVESTMENT_STAGE.DECLARATION:
                RouteManager.navigateToPage("/investments/employee-it-declaration", `id=${data.employee.userId}&name=${data.employee.employeeName}&employeeData=true`);
                break;
            case INVESTMENT_STAGE.ACTUAL:
                RouteManager.navigateToPage("/investments/employee-poi", `id=${data.employee.userId}&name=${data.employee.employeeName}&employeeData=true`);
                break;
            case INVESTMENT_STAGE.APPROVED:
                RouteManager.navigateToPage("/investments/employee-approval", `id=${data.employee.userId}&name=${data.employee.employeeName}&employeeData=true`);
                break;
        }
    }

    return (
        <>
            {!userData && <div className="parent-width parent-height">
                <div className="row parent-height" >
                    <div className="column parent-width flex-1 parent-height">
                        <div className="column parent-width mb-s position-relative flex-1 ">
                            <DataGridHolderPayroll
                                tableName={TABLES.PEOPLE_EMPLOYEE_TAX_DECLARATION}
                                displayTableName={EMPLOYEE_STAGE[STAGE]}
                                allowColumnEdit={false}
                                allowColumnDelete={false}
                                allowColumnShift={false}
                                allowSearch={false}
                                allowFilter={false}
                                onRowDelete={onDeleteEmployee}
                                onRowEdit={(data) => {
                                    onRowEdit(data);
                                }}
                                onRowClick={(obj) => {
                                    // Use later
                                    // const {rowIndex, rowData} = {...obj};
                                    // onRowClick(rowIndex, rowData);
                                }}
                                refresh={refresh}
                                allowRowAdd={false}
                                allowDataExport={false}
                                gridData={employee}
                                onSearch={onSearch}
                                onColumnAdd={newColumnAdded}
                                onFilter={onFilter}
                                filter={employee.filter}
                                onRowAdd={onRowAdd}
                                onPaginationClick={(requestedPageNumber) => {
                                    const config = {
                                        ...EmployeeTaxService.apiConfig,
                                        currentPage: requestedPageNumber,
                                        stage:STAGE
                                    };
                                    loadEmployee(config);
                                }}
                                currentPage={currentPage}
                                totalPageCount={totalPageCount}
                                isActionEnabled={getHasResetPermission(STAGE)}
                                allowRowEdit={true}
                            />
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default Employees;
